import { movieCategories, navLinks } from "@/mocks/home";

export default function Footer() {
  const types = movieCategories.filter((c) => c !== "全部");

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                茶杯狐影视
              </span>
            </div>
            <p className="mt-4 text-sm text-background-100/70 leading-relaxed max-w-xs">
              一个围绕在线观看、免费观看、高清播放、下载、缓存与无广告观看整理的集中入口，
              帮助你在不同场景下找到合适的观看方式。
            </p>
          </div>

          <nav aria-label="页面分区">
            <h3 className="font-heading text-sm font-bold text-background-50">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-100/70 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">内容类型</h3>
            <ul className="mt-4 space-y-2.5">
              {types.map((type) => (
                <li key={type}>
                  <a
                    href="#catalog"
                    className="text-sm text-background-100/70 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {type}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">使用提示</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/70">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-400"></i>
                优先选择稳定的网络环境
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-400"></i>
                播放缓慢时切换线路
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-400"></i>
                出行前提前缓存或下载
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-400"></i>
                长时间观看注意适度休息
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/55 text-center sm:text-left">
            © {new Date().getFullYear()} 茶杯狐影视 · 本站内容为信息整理与观看指引，具体片源以实际页面为准。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs text-background-100/70 hover:text-primary-300 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}